import _ from 'lodash';
import axios from 'axios';

async function getShipViaOptions(
  items: { itemCode: string; quantity: number }[],
  shipCountryIso3: string,
  shipPostalCode: string,
  shipCity: string,
  shipState: string,
  userStatusCode: string,
  autoShipCode: string,
  userId: string
): Promise<{ value: number; label: string; description: string }[]> {
  const params = {
    items: JSON.stringify(items),
    shipCountryIso3: shipCountryIso3,
    shipPostalCode: shipPostalCode,
    shipCity: shipCity,
    shipState: shipState ?? '',
    userStatusCode: userStatusCode,
    autoShipCode: autoShipCode,
    userId: userId,
  };
  const response = await axios.get('/api/cart/ship-via-options', {
    params: params,
  });

  return response.data.viaOptions;
}

/**
 * Gets the current currency code from the server and returns it.
 *
 * @return {Promise<string>}
 */
export default _.memoize(getShipViaOptions, (...args) => JSON.stringify(args));
